import API from "./api";

export const notifyWebsiteVisit = (visitDetails) =>
  API.post("/visitors/visit", visitDetails);
